<template>
  <div>
    <md-card>
      <md-card-header>
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <h4 class="title">Enquiries</h4>
            <p class="category">Contact History</p>
          </div>

          <div class="md-layout-item md-size-10 text-right">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="addEnquiry"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top"
                >Create a new Enquiry<br />for
                {{ this.customer.full_name }}</md-tooltip
              >
            </md-button>
          </div>
        </div>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <time-line
              plain
              type="simple"
              id="enquiry_timeline"
              v-if="enquiries.length"
            >
              <time-line-item
                inverted
                badge-type="primary"
                badge-icon="chat"
                v-for="enquiry in enquiries"
                :key="enquiry.id"
              >
                <div class="md-layout" slot="header">
                  <div class="md-layout-item md-size-60">
                    <i class="fas fa-clock text-primary"></i>
                    {{ enquiry.created_at | formatDateTime }}
                  </div>
                  <div
                    class="md-layout-item md-size-40 heat text-right"
                    :class="ratingColour(enquiry.heat)"
                  >
                    <div
                      class="badge badge-success status"
                      :class="enquiry.status.value"
                    >
                      <strong>{{ enquiry.status.description }}</strong>
                    </div>
                    <i
                      v-for="(n, i) in enquiry.heat"
                      :key="i"
                      class="fas fa-star"
                    ></i>
                  </div>
                </div>
                <div class="md-layout md-alignment-bottom-left" slot="content">
                  <div class="md-layout-item md-size-60 enquiry-summary">
                    <ul>
                      <li>
                        <span>TOURS : </span>{{ tourTitles(enquiry.tours) }}
                      </li>
                      <li>
                        <span>TRAVEL DATE : </span
                        >{{ travelDate(enquiry.travel_date) }}
                      </li>
                      <li>
                        <span>INTERACTIONS : </span
                        >{{ enquiry.interactions_count }}
                      </li>
                      <li>
                        <span>VALUE : </span
                        >{{ enquiry.value ? enquiry.value : "n/a" }}
                      </li>
                    </ul>
                  </div>
                  <div class="md-layout-item md-size-40 text-right ">
                    <md-button
                      :to="{
                        name: 'Enquiry Overview',
                        params: { id: enquiry.id }
                      }"
                      class="md-primary md-dense"
                    >
                      <md-icon>visibility</md-icon> view...
                      <md-tooltip md-direction="top"
                        >View Enquiry Details</md-tooltip
                      >
                    </md-button>
                    <md-button
                      class="md-danger md-dense"
                      @click.stop="deleteEnquiry(enquiry)"
                    >
                      <md-icon>delete</md-icon>
                      <md-tooltip md-direction="top">Delete Enquiry</md-tooltip>
                    </md-button>
                  </div>
                </div>
              </time-line-item>
            </time-line>
            <md-empty-state
              v-else
              md-label="First Contact"
              md-description="Start a conversation"
            >
              <md-button class="md-primary md-raised" @click="addEnquiry"
                >Add an enquiry</md-button
              >
            </md-empty-state>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <enquiry-dialog
      :enquiryDialog="showEnquiryDialog"
      :customer="customer"
      @cancel="showEnquiryDialog = false"
      @enquiry-created="newEnquiry"
    />
  </div>
</template>
<script>
import moment from "moment";
import customerApi from "@/services/api/customer";
import enquiryApi from "@/services/api/enquiry";
import { TimeLine, TimeLineItem } from "@/components";
import EnquiryDialog from "@/pages/Enquiry/Dashboard/EnquiryDialog.vue";
import _filter from "lodash/filter";
import confirm from "@/helpers/deleteConfirm";

export default {
  props: ["customer"],

  data() {
    return {
      enquiries: [],
      showEnquiryDialog: false
    };
  },

  filters: {
    travelDate: function(date) {
      return moment(date).format("MMMM YYYY");
    }
  },

  components: {
    TimeLine,
    TimeLineItem,
    EnquiryDialog
  },

  methods: {
    getEnquiries() {
      customerApi.getEnquiries(this.customer).then(resp => {
        this.enquiries = resp.data;
      });
    },

    newEnquiry(enquiry) {
      this.showEnquiryDialog = false;
      this.$router.push({
        name: "Enquiry Overview",
        params: { id: enquiry.id }
      });
    },

    addEnquiry() {
      this.showEnquiryDialog = true;
    },

    deleteEnquiry(enquiry) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          enquiryApi.deleteEnquiry(enquiry.id).then(response => {
            this.enquiries = _filter(this.enquiries, function(item) {
              return item.id !== enquiry.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    ratingColour(heat) {
      let temp = "";
      switch (heat) {
        case 1:
        case 2:
          temp = "cool";
          break;
        case 3:
          temp = "medium";
          break;
        case 4:
        case 5:
          temp = "hot";
          break;
      }
      return temp;
    },

    travelDate(travelDate) {
      return travelDate ? moment(travelDate).format("MMMM YYYY") : "n/a";
    },

    tourTitles(tours) {
      return tours.map(tour => tour.title).join(", ");
    }
  },

  computed: {},

  created() {},

  beforeMount() {},

  mounted() {
    this.getEnquiries();
  }
};
</script>
<style lang="scss" scoped>
.heat {
  align-items: center;
}
.status {
  color: rgba(0, 0, 0, 0.87);
  margin-right: 10px;

  &.ongoing {
    background-color: #f6f6f6;
  }
  &.negative {
    background-color: #f6acac;
  }
  &.positive {
    background-color: #cef2d4;
  }
  &.deferred {
    background-color: #faedc5;
  }
}
</style>
